import { css } from '@emotion/react';

const labelLineHeight = css`
    line-height: 1.4166rem;
`;

export default labelLineHeight;
